<template>
    <div class="login">
        <div class="login__wrap">
            <div class="login__box login__box--join">
                <P class="login__title">마이페이지</P>
                <div class="login__inputs">
                    
                    <!--로그인 인풋-->
                    <div class="input-box__wrap input-box__wrap--double">
                        <div class="input-box">
                            <label>*기관명</label>
                            <input type="text" v-model="state.name" disabled>
                        </div>
                        <div class="input-box">
                            <label>*기관 담당자 성함</label>
                            <input type="text" v-model="state.adminName" disabled>
                        </div>
                        <div class="input-box">
                            <label v-if="checkUserId.privilege !== 'user'">*기관 담당자 이메일</label>
                            <label v-if="checkUserId.privilege === 'user'">*이메일</label>
                            <input type="text" v-model="state.mail">
                        </div>
                        <div class="input-box">
                            <label>*아이디</label>
                            <input type="text" v-model="state.id" disabled>
                        </div>
                        <div class="input-box" v-if="checkUserId.privilege !== 'user'">
                            <label>*기관 담당자 연락처</label>
                            <input type="text" v-model="state.num">
                        </div>
                        <div class="input-box">
                            <label>*비밀번호</label>
                            <input type="password" v-model="state.password">
                        </div>
                        <div class="input-box">
                            <label>*비밀번호 확인</label>
                            <input type="password" v-model="state.passwordConfirm">
                        </div>
                    </div>
                    <button type="button" class="btn btn--primary btn--half" @click="goUpdate">수정</button>
                    <!--로그인 옵션-->
                    <!-- <div class="login__option">
                        <a class="login__option--left" @click="goMenu('user')" src="">로그인하기</a>
                    </div> -->

                </div>
            </div>
        </div>
    </div>
    <div class="footer">
    <p class="footer__address">
      08506 서울시 금천구 가산디지털2로 108, 905호(가산동, 뉴티캐슬) 
      <span>대표전화: 070-4489-7241</span>
    </p>
    <span class="footer__copy">Copyright by 2025 아트너컨설팅. All Right Reserved</span>
  </div>
</template>
   
<script setup>
import { ref, computed, onMounted, onUnmounted ,reactive  } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import * as Utils from '@/common/util/util'
import { updateOrgData } from '@/api/org'
import { getUserMyPage,userPwInit } from '@/api/user'
const store = useStore()
const router = useRouter()
const checkUserId = computed(() => store.state.temp.userInfo )
const state = reactive({
    name: '',
    num: '',
    mail : '',
    adminName : '',
    id: '',
    password: '',
    passwordConfirm : '',
});


const checkField = () => {

    if (Utils.isEmpty(state.name)) {
		alert("기관명을 입력해주세요")
		return false
	}
    if (Utils.isEmpty(state.num)) {
		alert("기관 담당자 번호를 입력해주세요")
		return false
	}
    if (Utils.isEmpty(state.mail)) {
		alert("이메일을 입력해주세요")
		return false
	}
    if (Utils.isEmpty(state.adminName)) {
		alert("담당자 성함을 입력해주세요요")
		return false
	}
    if (!validateEmail(state.mail)) {
        alert("올바른 이메일 형식이 아닙니다.")
        return false
    } 
    if (Utils.isEmpty(state.id)) {
		alert("아이디를 입력해주세요")
		return false
	}

    if (state.password != state.passwordConfirm) {
		alert("비밀번호와 비밀번호 확인 값이 다릅니다.")
		return false
	}

	if (Utils.isEmpty(state.password)) {
		alert("비밀번호를 입력해주세요")
		return false
	}
	if (Utils.isEmpty(state.passwordConfirm)) {
		alert("비밀번호 확인창을 확인해주세요")
		return false
	}
	return true
}

const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

const goUpdate = async () => {
    if (!checkField()) return false;

    if (confirm("수정 하시겠습니까?")) {
        try {
            // 사용자 권한이 'user'일 경우
            let pwInitSuccess = false;
            if (checkUserId.value.privilege === 'user') {
                let param = {
                    memberCode: checkUserId.value.memberCode,
                    memberPassword: state.password,
                    userMail : state.mail
                };
                let rtn = await userPwInit(param); // 비밀번호 초기화 API 호출
                
                if (rtn.result === 'ok') {
                    pwInitSuccess = true;
                    alert(rtn.resultMsg);
                    router.push({ name: 'Home' }).then(() => {
                        window.location.reload(); // 강제 새로고침
                    });
                } else {
                    alert(rtn.resultMsg);
                    return; // 비밀번호 초기화 실패 시 종료
                }
            } 
            
            // 사용자 권한이 'user'가 아닐 때
            if (checkUserId.value.privilege !== 'user') {
                let pwInitParam = {
                    memberCode: checkUserId.value.memberCode,
                    memberPassword: state.password,
                    userMail : state.mail
                };

                let orgUpdateParam = {
                    organizationCode: checkUserId.value.organizationCode,
                    mail: state.mail,
                    repNum: state.num
                };

                // 비밀번호 초기화
                let pwInitResult = await userPwInit(pwInitParam);
                let orgUpdateResult = await updateOrgData(orgUpdateParam);

                // 두 작업 모두 성공했는지 확인
                if (pwInitResult.result === 'ok' && orgUpdateResult.result === 'ok') {
                    alert("비밀번호와 기관 정보가 성공적으로 업데이트되었습니다.");
                    router.push({ name: 'Home' }).then(() => {
                        window.location.reload(); // 강제 새로고침
                    });
                } else {
                    if (pwInitResult.result !== 'ok') {
                        alert(pwInitResult.resultMsg || "비밀번호 초기화 실패");
                    }
                    if (orgUpdateResult.result !== 'ok') {
                        alert(orgUpdateResult.resultMsg || "기관 정보 수정 실패");
                    }
                }
            }
        } catch (error) {
            console.error("수정 중 오류 발생:", error);
            alert("오류가 발생했습니다. 다시 시도해주세요.");
        }
    }
};


const getMyPageData = async () => {
    let param = {
        memberCode: checkUserId.value.memberCode
    };

    try {
        let rtn = await getUserMyPage(param);

        if (rtn?.result === 'ok' && rtn?.data) {
            const data = rtn.data;

            // API 응답을 state에 매핑
            state.name = data.organizationName || '';
            state.adminName = data.memberName || '';
            state.mail = data.userMail || '';
            state.num = data.phonNumber || '';
            state.id = data.id || '';

            console.log("마이페이지 데이터가 성공적으로 매핑되었습니다.");
        } else {
            console.error("데이터 조회 실패:", rtn?.resultMsg || "알 수 없는 오류");
            alert(rtn?.resultMsg || "데이터를 불러오지 못했습니다.");
        }
    } catch (error) {
        console.error("getMyPageData 오류:", error);
        alert("오류가 발생했습니다. 다시 시도해주세요.");
    }
};


onMounted(async () => {
    console.log("로그인한 사람의 권한" + checkUserId.value.memberCode)
    await getMyPageData();
})
</script>

<style scoped >


/* 📝 페이지 레이아웃 */
.login {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 전체 화면 높이를 채움 */
}

.login__wrap {
  flex: 1; /* 남은 공간을 채움 */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.login__box {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 30px;
  max-width: 600px;
  width: 100%;
  text-align: center;
}

.login__title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.input-box label {
  font-size: 1rem; /* 라벨 폰트 크기 */
  font-weight: 500;
  margin-bottom: 8px;
  text-align: left;
}

.btn {
  display: inline-block;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn--primary {
  background-color: #007bff;
  color: #fff;
  border: none;
  margin-top: 10px;
}

.btn--primary:hover {
  background-color: #0056b3;
}

.btn--half {
  width: 50%;
  margin: 0 auto;
}

/* 📝 푸터 스타일 */
.footer {
    background-color: #f4f4f4; /* 원하는 배경색 */
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
    color: #333;
    margin: 0;
    width: 100%; /* 전체 너비 사용 */
    box-sizing: border-box; /* 패딩과 보더 포함 */
}

.footer__address {
    margin-bottom: 8px;
}

.footer__copy {
  background-color: #f4f4f4;
  font-size: 12px;
  color: #666;
}


/* 📝 반응형 디자인 */
@media (max-width: 768px) {
  .input-box__wrap {
    grid-template-columns: 1fr;
  }

  .btn--half {
    width: 100%;
  }

  .login__box {
    padding: 20px;
  }
}


</style>